import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { getCurrentLocation } from '../../actions/currentLocation';
import { setCartPanel } from '../../actions/panels';
import { cartInfoUpdate, loadCart } from '../../actions/cart';
import { validateLogin } from '../../actions/auth';
import { hasCartItems, renderCartItems } from '../../utils/cartItemUtil';
import { ModalCloseButton } from '../common/ModalCloseButton';
import { Link } from 'react-router-dom';
import Tabs from '../common/NavigationTabs';
import OrderInformation from '../cart/OrderInformation';
import OrderCheckout from '../cart/OrderCheckout';
import OrderComplete from '../cart/OrderComplete';
import SelectPayment from '../cart/SelectPayment';

class CartPage extends React.Component {

    componentDidMount() {

        if (!this.props.currentLocation.location || this.props.currentLocation.location.id != this.props.match.params.lid) {
            this.props.dispatch(getCurrentLocation(this.props.match.params.lid, false, {}, {}, true));
        }

        const token = window.localStorage.getItem('c2o.token');
        if (token) {
            this.props.dispatch(validateLogin({ token }));
        }

        // determine if there is a cart that needs to be updated
        if (!this.props.cart.cart_loaded) {
            const storedCartJson = window.localStorage.getItem('c2o.cart.'+this.props.match.params.lid);

            if (storedCartJson) {
                const now = new Date();
                const storedCartInfo = JSON.parse(storedCartJson);
                const expiry = storedCartInfo.expiry;
                const cart = storedCartInfo.cart;

                // check the expiry date
                if (now.getTime() < expiry) {
                    this.props.dispatch(loadCart(cart));
                } else {
                    window.localStorage.removeItem('c2o.cart.'+this.props.match.params.lid);
                }
            }

            this.props.dispatch(cartInfoUpdate({prop: 'cart_loaded', value: true}));
        }

    }

    componentDidUpdate() {

        // determine if there is a cart that needs to be updated
        const storedCartJson = window.localStorage.getItem('c2o.cart.'+this.props.match.params.lid);
        const storedCartInfo = JSON.parse(storedCartJson);
        let storedCart = {};
        if (storedCartInfo && storedCartInfo.cart) {
            storedCart = storedCartInfo.cart;
        }
        
        // make sure that the cart is loaded so that we're not accidentally overwriting anything
        if (this.props.cart.cart_loaded) {
            let cartJson = JSON.stringify(this.props.cart);
            let cart = JSON.parse(cartJson);
            delete cart.cart_loaded; 

            if (!_.isEqual(storedCart, cart)) {
                const now = new Date();
                const storageCart = {
                    cart,
                    expiry: now.getTime() + (60*60*1000)
                };

               window.localStorage.setItem('c2o.cart.'+this.props.match.params.lid, JSON.stringify(storageCart));
            }
        }

        if(this.props.curPanel == "current_status"){
            this.props.history.push('/'+this.props.match.params.sitename+'/'+this.props.match.params.lid+'/history');
        }

    }

    renderTotals() {

        const {
            pizzas,
            fooditems,
            addons,
            beverages,
            specials
        } = this.props.cart.items;

        // @TODO: we need to set up dynamic taxes here once we have the API configured to do so
        let subtotal = 0.00;
        if (pizzas.length > 0) {
            pizzas.forEach((theItem) => {
                subtotal += parseFloat(theItem.total_item_price);
            });
        }
        if (fooditems.length > 0) { 
            fooditems.forEach((theItem) => {
                subtotal += parseFloat(theItem.total_item_price);
            });
        }
        if (beverages.length > 0) { 
            beverages.forEach((theItem) => {
                subtotal += parseFloat(theItem.total_item_price);
            });
        }
        if (specials.length > 0) {
            specials.forEach((theItem) => {
                subtotal += parseFloat(theItem.total_item_price);
            });
        } 
        if (addons.length > 0) {
            addons.forEach((theItem) => {
                subtotal += parseFloat(theItem.total_item_price);
            });
        }

        subtotal = +(Math.round(subtotal + "e+2")  + "e-2");
        let taxes = 0;
        if (this.props.cart.taxes > 0) {
            taxes = +(Math.round((parseFloat(subtotal) * (parseFloat(this.props.currentLocation.tax_rate) / 100.0)) + "e+2")  + "e-2");
        }
        let total = +(Math.round((subtotal + taxes) + "e+2")  + "e-2");

        return (
            <div>

                <div className="total-wrapper">
                    <div className="receipt-line">
                        <p className="paragraph in-receipt">Sub Total</p>
                        <p className="paragraph in-receipt price-item">{subtotal.toFixed(2)}</p>
                    </div>
                    {(this.props.cart.taxes > 0) && (
                         <div className="receipt-line">
                         <p className="paragraph in-receipt">Taxes</p>
                         <p className="paragraph in-receipt price-item">{taxes.toFixed(2)}</p>
                     </div>
                    )}
                    {/* Total row */}
                    <div className="total">
                        <strong className="total-bold">Total:</strong> <span className="total-amount-text">{ total.toFixed(2)}</span>
                    </div>
                </div>
            </div>
        );
    }

    renderActivePanel() {
        switch(this.props.curPanel) {

            case 'order_information':
                return this.renderOrderInformation();

            case 'checkout':
                return this.renderCheckout();

            case 'select_payment':
                return this.renderSelectPayment();

            case 'complete':
                return this.renderCompleted();
            
            default:
                return this.renderCart();
        }
    }

    renderCart() {
        return (
            <div className="cart-section">
                <ModalCloseButton 
                      clickAction={() => this.props.history.goBack()}
                />
                <h1 className="heading" style={{ paddingTop: 40}}>Cart</h1>
                <div className="bottom-clearance">
                    {renderCartItems(this.props.cart.items, false)}
                    {this.renderTotals()}
                </div>
                <div className="cart-information-continue">
                    {(this.props.logged_in) ? (
                        <div className="fixed-cart-button">
                            <p>Everything looks good? Let's review your Order Information.</p>
                            <a
                            className="proceed-button"
                                onClick={() => {
                                    // make sure that we set up the user's information in their cart into
                                    this.props.dispatch(cartInfoUpdate({prop: 'name', value: (this.props.loggedUser.first_name + " " + this.props.loggedUser.last_name).trim()}));
                                    this.props.dispatch(cartInfoUpdate({prop: 'phone', value: this.props.loggedUser.phone}));
                                    this.props.dispatch(cartInfoUpdate({prop: 'email', value: this.props.loggedUser.email}));

                                    // go to the next screen
                                    this.props.dispatch(setCartPanel('order_information'))
                                }}
                            >
                                Proceed with Checkout
                            </a>
                        </div>
                    ) : (
                        <div className="fixed-cart-button">
                            <div className="cart-login-window">
                                <p>It looks like you aren't signed in. Sign up or Log in for faster checkouts!</p>
                                <a
                                    onClick={() => {
                                        this.props.history.push('/'+this.props.match.params.sitename+'/'+this.props.match.params.lid+'/account/', {
                                            redirectTo: 'order_information'
                                        });
                                    }}
                                        >
                                    Login / Sign Up
                                </a>
                                <a
                                        className="secondary"
                                        onClick={() => this.props.dispatch(setCartPanel('order_information'))}
                                >
                                    Continue as Guest
                                </a>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    renderOrderInformation() {
        return <OrderInformation />;
    }

    renderCheckout() {
        return <OrderCheckout />;
    }

    renderCompleted() {
        return <OrderComplete />;
    }

    renderSelectPayment() {
        return <SelectPayment />;
    }
                 
    render() {
        if (hasCartItems(this.props.cart.items) || this.props.curPanel == 'complete') {
            
            return (
                <div className="breakpointContainer">
                    {this.renderActivePanel()}
                    <Tabs 
                        sitename={this.props.match.params.sitename}
                        lid={this.props.match.params.lid}
                        section="eats"
                    />
                </div>
            );
        }
        else {
            return (
                <div className="breakpointContainer">
                    <div className="login-section no-items-top-padding"> 
                         <div className="close-button">         
                            <ModalCloseButton 
                                clickAction={() => this.props.history.goBack()}
                            />             
                        </div>
                        <div className="empty-cart-title">
                            <p>The Cart is Empty!</p>
                        </div>
                        <div>
                            <p className="empty-cart-text">Looks like you don't have any items in the cart.</p>
                        </div>
                    </div>

                    <Tabs 
                        sitename={this.props.match.params.sitename}
                        lid={this.props.match.params.lid}
                        section="eats"
                    />
                </div>  
            );
        }  
    }
}

const mapStateToProps = (state) => {
    return {
        curPanel: state.panels.cart,
        logged_in: state.auth.logged_in,
        loggedUser: state.auth.user,
        cart: state.cart,
        currentLocation: state.currentLocation.info
    };
  };

export default connect(mapStateToProps)(CartPage);